import { get, postJsonAdmin } from './_core.js';
import type { SenseReviewCase, SenseReviewDecision, SenseReviewStats } from '@orborix/shared-types';
export const fetchSenseReviews = () =>
  get<{
    cases: Array<{
      id: string;
      word: string;
      reason: string;
      status: string;
      createdAt: string;
      humanAction: string | null;
    }>;
    stats: SenseReviewStats;
  }>('/admin/lexicon-reports');
export const fetchSenseReview = (id: string) =>
  get<SenseReviewCase>(`/admin/lexicon-reports/${id}`);
export const decideSenseReview = (id: string, body: SenseReviewDecision) =>
  postJsonAdmin<{ id: string }>(`/admin/lexicon-reports/${id}/decision`, body);
